import jwtDecode from 'jwt-decode';
import {Cookies} from "react-cookie";

const COOKIE_TOKEN = 'student-app-token';

const getToken = () => {
    const cookies = new Cookies();

    const token = cookies.get(COOKIE_TOKEN);

    return token || null;
};

const setToken = (accessToken) => {
    const cookieManager = new Cookies();
    cookieManager.set(COOKIE_TOKEN, accessToken);
};

const isUserAuthenticated = () => {
    const token = getToken();
    if (!token) return false;

    const parsedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    return parsedToken.exp > currentTime;
};

const clearToken = () => {
    const cookieManager = new Cookies();
    cookieManager.remove(COOKIE_TOKEN);
};


export {isUserAuthenticated, getToken, setToken, clearToken};